import React, { useContext } from 'react';
import { Route, ScrollToTop, Routes } from '@thd-olt-component-react/router';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { AppContext } from '@thd-nucleus/app-render';
import { Error } from './pages';
import { getRoutes } from './routes';
import './styles/app.scss';

const App = ({ serverPages }) => {
  const { instance } = useContext(AppContext);
  const { channel } = useContext(ExperienceContext);
  const {
    currentRouteName,
    currentRouteComponent
  } = instance.router;
  const routes = getRoutes(currentRouteName, currentRouteComponent, channel, serverPages);

  return (
    <>
      <ScrollToTop />
      <Routes>
        <Route
          exact
          path={routes.product.path}
          element={<routes.product.component channel={channel} />}
          errorElement={<Error />}
        />
        <Route
          exact
          path={routes.vehicleStorage.path}
          element={
            channel === 'mobile'
              ? <routes.vehicleStorageMobile.component channel={channel} />
              : <routes.vehicleStorage.component channel={channel} />
          }
          errorElement={<Error />}
        />
        <Route
          exact
          path={routes.wallStorage.path}
          element={
            channel === 'mobile'
              ? <routes.wallStorageMobile.component channel={channel} />
              : <routes.wallStorage.component channel={channel} />
          }
          errorElement={<Error />}
        />
        <Route
          path={routes.collection.path}
          element={
            channel === 'mobile'
              ? (<routes.collectionMobile.component />)
              : (<routes.collection.component />)
          }
          errorElement={<Error />}
        />
        <Route
          path={routes.cabinetVisualizer.path}
          element={
            channel === 'mobile'
              ? (<routes.cabinetVisualizerMobile.component />)
              : (<routes.cabinetVisualizer.component />)
          }
          errorElement={<Error />}
        />
        <Route exact path={routes.home.path} element={<routes.home.component />} />
        <Route
          path={routes.sandbox.path}
          element={<routes.sandbox.component channel={channel} />}
          errorElement={<Error />}
        />
        <Route
          path={routes.cabinetVisualizerDefault.path}
          element={
            channel === 'mobile'
              ? (<routes.cabinetVisualizerMobile.component landingPage />)
              : (<routes.cabinetVisualizer.component landingPage />)
          }
          errorElement={<Error />}
        />
        <Route
          path={routes.cabinetVisualizerSDTDefault.path}
          element={<routes.cabinetVisualizer.component landingPage />}
          errorElement={<Error />}
        />
        <Route
          path={routes.cabinetVisualizerSDT.path}
          element={<routes.cabinetVisualizer.component landingPage={false} />}
          errorElement={<Error />}
        />
        <Route path="/error" element={<Error />} errorElement={<Error />} />
        <Route path="/" element={<Error />} />
      </Routes>
    </>
  );
};

App.propTypes = {};

App.defaultProps = {};

export default App;
